"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils");

var _hooks = require("../hooks");

var TableState = function TableState(_ref) {
  var render = _ref.render;
  var tableState = (0, _hooks.useTableState)();
  /* istanbul ignore if */

  if (!(0, _utils.isFunction)(render)) {
    return null;
  }

  return render(tableState);
};

TableState.propTypes = {
  render: _propTypes["default"].func
};
var _default = TableState;
exports["default"] = _default;